import React from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../mock/data';
import { useLang } from '../i18n';
import { toAbsoluteMediaUrl } from '../lib/media';

const APPLE_URL = 'https://apps.apple.com/af/app/yup-your-utility-points/id6738097216';
const GOOGLE_URL = 'https://play.google.com/store/apps/details?id=yupdesenzano.app';

const APPLE_BADGE =
  'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83';
const GOOGLE_BADGE =
  'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png';

export default function Download() {
  const { t } = useLang();
  // Wrap in quotes: the hero URL contains "(23)" — unquoted parens break CSS url() parsing
  // and the browser silently drops the entire style attribute.
  const heroBgCss = `url("${toAbsoluteMediaUrl(SITE.heroBg)}")`;
  return (
    <div className="relative w-full" style={{ minHeight: '100vh' }}>
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: heroBgCss }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/85" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-20 text-center text-white flex flex-col items-center">
        <img
          src={SITE.logo}
          alt="YUP logo"
          className="h-32 md:h-44 w-auto drop-shadow-2xl fade-in-up"
          data-testid="download-logo"
        />
        <h2 className="mt-6 text-sm md:text-base tracking-[0.3em] font-medium text-white/95 fade-in-up fade-in-up-delay-1">
          {t('tagline')}
        </h2>
        <h1 className="mt-3 text-4xl md:text-5xl tagline-display fade-in-up fade-in-up-delay-2">
          {t('welcome')}
        </h1>
        <p className="mt-4 text-base md:text-lg tracking-[0.25em] text-[color:var(--yup-primary)] fade-in-up fade-in-up-delay-2">
          {t('travelWithUs')}
        </p>

        <div className="mt-14 fade-in-up fade-in-up-delay-3">
          <h3 className="section-title" style={{ color: 'var(--yup-primary)' }}>
            {t('availableOn')}
          </h3>

          {/* Uniform badge sizes: fixed height, w-auto keeps each logo's proportions */}
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8">
            <a
              href={APPLE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="store-badge"
              data-testid="download-apple-btn"
              aria-label="Download on the Apple App Store"
            >
              <img
                src={APPLE_BADGE}
                alt="Download on the App Store"
                className="h-[54px] w-auto block"
              />
            </a>
            <a
              href={GOOGLE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="store-badge"
              data-testid="download-google-btn"
              aria-label="Get it on Google Play"
            >
              <img
                src={GOOGLE_BADGE}
                alt="Get it on Google Play"
                className="h-[54px] w-auto block"
              />
            </a>
          </div>
        </div>

        <div className="mt-16 fade-in-up fade-in-up-delay-3">
          <Link
            to="/"
            className="btn-primary inline-block"
            data-testid="download-back-home-btn"
          >
            {t('discoverSite')}
          </Link>
        </div>
      </div>
    </div>
  );
}
